enum Gender {
  Female = 'F',
  Male = 'M',
  Other = 'O',
}

export default Gender;

export const Gendernyms = {
  F: 'woman',
  M: 'man',
  O: 'person',
};
